import { supabase } from './supabase';

export interface TaxRate {
  id: string;
  business_id: string;
  name: string;
  description: string;
  rate: number;
  is_compound: boolean;
  is_default: boolean;
  created_at: string;
  updated_at: string;
}

export async function getTaxRates(businessId: string) {
  const { data, error } = await supabase
    .from('tax_rates')
    .select('*')
    .eq('business_id', businessId)
    .order('created_at');

  if (error) throw error;
  return data as TaxRate[];
}

export async function createTaxRate(taxRate: Omit<TaxRate, 'id' | 'created_at' | 'updated_at'>) {
  const { data, error } = await supabase
    .from('tax_rates')
    .insert([taxRate])
    .select()
    .single();

  if (error) throw error;
  return data as TaxRate;
}

export async function updateTaxRate(id: string, updates: Partial<TaxRate>) {
  const { data, error } = await supabase
    .from('tax_rates')
    .update(updates)
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data as TaxRate;
}

async function deleteTaxRate(id: string) {
  const { error } = await supabase
    .from('tax_rates')
    .delete()
    .eq('id', id);

  if (error) throw error;
}

// Export the deleteTaxRate function
export { deleteTaxRate };